import { Text, Title } from '~/components';

import { titleGroupStyle } from './AuthLayoutTitleGroup.css';

type Props = {
  eyebrow?: string;
  subtitle: string;
  title: string;
};

export const AuthLayoutTitleGroup = ({ eyebrow, subtitle, title }: Props) => {
  return (
    <div className={titleGroupStyle}>
      <Title as="h1" eyebrow={eyebrow}>
        {title}
      </Title>

      <Text>{subtitle}</Text>
    </div>
  );
};
